"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InlineAlert", {
    enumerable: true,
    get: function() {
        return InlineAlert;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var messageColor = {
    success: {
        color: "text-success"
    },
    error: {
        color: "text-error"
    },
    warning: {
        color: "text-warning"
    },
    info: {
        color: "text-secondary"
    }
};
var InlineAlert = {
    parts: [
        "container",
        "description",
        "icon"
    ],
    baseStyle: function(param) {
        var status = param.status, theme = param.theme;
        return {
            container: {
                alignItems: "center",
                gap: "0.5rem"
            },
            message: _object_spread({
                textStyle: "text-body-meta-regular"
            }, messageColor[status]),
            icon: _object_spread({}, theme.components.Alert.baseStyle({
                theme: theme
            }).icon.status[status])
        };
    }
};
